import { isEmpty } from 'lodash'

export const isEmptyArray = isEmpty
